<template>
  <section v-if="!promotionList" class="fou-promotion">
    <p class="fou-promotion__list__name">{{ $t('pages.dashboard.components.promotion.promotions_empty') }}</p>
    <div class="promotion-btn-link">
      <MdButton class="create-btn" @click="gotoPromotionPages(NEW_PROMOTION, '')">
        {{ $t('pages.dashboard.components.promotion.new_promo_create') }}
      </MdButton>
      <MdButton class="learnMore-btn" variant="ghost" @click="handleLearnMoreClick">
        <span class="bundleLearnMore">
          {{$t('pages.dashboard.components.promotion.learn_more') }}
        </span>
        <MdIconArrowLong class="learnMore-iocn" rotate="up-right" size="small"></MdIconArrowLong>
      </MdButton>
    </div>
  </section>
  <div v-if="promotionList && showPromotion" data-qa-id="expiring_promotions" class="fou-promotion">
    <div v-for="promotion in promotionList" :key="promotion.promotionId" data-qa-id="promotion-list"
      class="fou-promotion__list">
      <span data-qa-id="promotion-title" class="fou-promotion__list__name">{{ promotion.promoTitle }}</span>
      <div class="fou-promotion__list__desc">
        <span>{{
          $t('pages.dashboard.components.promotion.readable_end_date', { endDate: promotion.modifiedDate })
          }}</span>
        <edit-icon data-qa-id="single-promotion-navigation" class="promotion-arrow"
          @click="gotoPromotionPages(VIEW_PROMOTION, promotion.promotionId)" />
      </div>
    </div>
    <div class="footer-section">
      <MdButton data-qa-id="create-promotion-navigation" class="create-btn" @click="gotoPromotionPages(NEW_PROMOTION, '')">
        <percentage-star class="percentage-star" />
        {{ $t('pages.dashboard.components.promotion.new_promotion') }}
      </MdButton>
      <MdButton data-qa-id="all-promotion-navigation" class="all-promotions"variant="ghost" @click="gotoPromotionPages(PROMOTION_DASHBAORD, '')">
        {{ $t('pages.dashboard.components.promotion.all_promotion') }}
        <link-arrow class="ml-11" fill-color="#1A73E8"/>
      </MdButton>
    </div>
  </div>
</template>
<script src="./script.js"></script>
<style scoped>
.learnMore-btn, .create-btn, .all-promotions {
  margin-top: 24px;
}
.bundleLearnMore {
  font-size: 13px;
  line-height: 16px;
  color: #1a73e8;
  font-family: "Helvetica Now Text W05 Medium", Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-weight: 500;
}
.learnMore-iocn {
  margin-left: 4px;
}
.footer-section { 
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.all-promotions::part(md-button) {
  font-size: 13px;
  line-height: 16px;
  cursor: pointer;
  font-family: "Helvetica Now Text W05 Medium", Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-weight: 500;
}
@media (max-width: 719px) {
  .create-btn {
    width: 100%;
  }
  .all-promotions::part(md-button) {
    margin-top: 0;
  }
  .learnMore-btn {
    margin-top: 0;
  }
  .footer-section {
    display: flex;
    flex-direction: column;
  }
}
</style>
